import { useAuthentication } from '@heidelbergmaterials/fcl-authclient'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export function ShellUnauthenticated() {
  const { redirectToAuthenticator } = useAuthentication();

  return (
    <div className="min-h-screen bg-hc-bg flex flex-col font-sans">
      <nav className="bg-white border-b border-hc-border shadow-sm">
        <div className="flex items-center">
          <div className="bg-hc-green px-5 py-4">
            <img src="/static/hclogo.png" alt="Heidelberg Materials" className="h-8" />
          </div>
        </div>
      </nav>
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <Typography variant="h1" sx={{ fontWeight: 700, mb: 1 }}>Not signed in</Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>Sign in with your HeidelbergMaterials account to continue.</Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => void redirectToAuthenticator()}
          >
            Sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
